
// export default CompanyList;
import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { TextField, IconButton, Snackbar } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import axiosInstance from "../../Axios/axiosInstance";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

const CompanyList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          "/api/getCompanyRegistrations"
        );
        setData(response.data);
        setFilteredData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const filtered = data.filter((item) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [searchTerm, data]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (id) => {
    navigate(`/dashboard/edit-company/${id}`);
  };

  const handleDelete = (id) => {
    setDeleteItemId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      if (deleteItemId) {
        await axiosInstance.delete(
          `/api/deleteCompanyRegistration/${deleteItemId}`
        );
        fetchData();
        setDeleteSuccessMessage("Item deleted successfully.");
        setDeleteItemId(null);
      }
    } catch (error) {
      console.error("Error deleting entry:", error);
    }
    setOpenDialog(false);
  };

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("/api/getCompanyRegistrations");
      setData(response.data);
      setFilteredData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const columns = [
    "Establishment Unique Number",
    "Establishment Number",
    // "Establishment Description",
    // "Website",
    // "Email Id",
    // "Phone Number",
    // "Address",
    // "City",
    // "State",
    // "Pincode",
    "Contact Person Name",
    // "Contact Person E-Mail",
    // "Industry Type",
    // "Registration Date",
    // "Amount Paid",
    // "Payment Details",

    {
      name: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => (
          <>
            <IconButton
              onClick={() =>
                handleEdit(filteredData[tableMeta.rowIndex].establishmentid)
              }
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() =>
                handleDelete(filteredData[tableMeta.rowIndex].establishmentid)
              }
            >
              <Delete />
            </IconButton>
          </>
        ),
      },
    },
  ];

  const tableData = filteredData.map((row) => [
    row.establishmentid,
    row.establishmentnumber,
  
    row.contactpersonname,

  ]);

  const options = {
    filter: true,
    selectableRows: "none",
  };

  const formattedDate = (date) => {
    if (!date) {
      return "";
    }
    const options = { day: "numeric", month: "numeric", year: "numeric" };
    return new Date(date).toLocaleDateString("en-IN", options);
  };

  return (
    <>
      <Helmet>
        <title>ContactTab | Establishment List View</title>
      </Helmet>

      <MUIDataTable
        title={"Company Data"}
        data={tableData}
        columns={columns}
        options={options}
      />

      {/* Delete confirmation dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
      >
        <DialogTitle>Delete Item</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleConfirmDelete}>Delete</Button>
        </DialogActions>
      </Dialog>

      {deleteSuccessMessage && (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={true}
          autoHideDuration={3000}
          onClose={() => setDeleteSuccessMessage(null)}
          message={deleteSuccessMessage}
        />
      )}
    </>
  );
};

export default CompanyList;
